import { PagingRequestValues } from 'modules/organization/organizationApiTypes';

import { api } from 'services/api';

import { DSP_ADFORM, DSP_AMAZON, DSP_CRITEO, DSP_VISTAR } from '../../utils/constants';
import {
  REPORTS_TEMPLATES_URL,
  REPORTS_URL,
  REPORTS_DOWNLOAD_URL,
  REPORTS_STATUS_URL,
  ALL_TOUCH_REPORTS_URL,
  PERFORMANCE_REPORTS_URL,
  VISTAR_PERFORMANCE_REPORTS_URL,
  CRITEO_PERFORMANCE_REPORTS_URL,
  ADFORM_PERFORMANCE_REPORTS_URL,
  ADFORM_ALL_TOUCH_REPORTS_URL,
  AMAZON_PERFORMANCE_REPORTS_URL,
} from './constants';
import {
  ReportsPagingResponse,
  ReportTemplate,
  PerformanceReport,
  PerformanceReportCreatePayload,
  ReportStatusResponse,
  AllTouchReportCreatePayload,
  AllTouchReport,
} from './reportApiTypes';

const getReports = (payload: PagingRequestValues) => {
  const sortBy = payload.sortBy ? `&sortBy=${payload.sortBy}` : '';
  const direction = payload.direction ? `&direction=${payload.direction}` : '';
  const search = payload.search ? `&search=${encodeURIComponent(payload.search)}` : '';

  const optionalParamsString = sortBy && direction ? sortBy.concat(direction, search) : search;

  return api.get<ReportsPagingResponse>(
    `${REPORTS_URL}?advertiserId=${payload.advertiserId}&page=${payload.page}&size=${payload.size}${optionalParamsString}`,
  );
};

const savePerformanceReport = (
  payload: PerformanceReportCreatePayload | AllTouchReportCreatePayload,
  dsp: string | null,
) => {
  let URL;

  switch (dsp) {
    case DSP_VISTAR:
      URL = VISTAR_PERFORMANCE_REPORTS_URL;
      break;
    case DSP_CRITEO:
      URL = CRITEO_PERFORMANCE_REPORTS_URL;
      break;
    case DSP_ADFORM:
      URL = ADFORM_PERFORMANCE_REPORTS_URL;
      break;
    case DSP_AMAZON:
      URL = AMAZON_PERFORMANCE_REPORTS_URL;
      break;
    default:
      URL = PERFORMANCE_REPORTS_URL;
      break;
  }

  return api.post<PerformanceReport>(URL, payload);
};

const saveAllTouchReport = (payload: AllTouchReportCreatePayload, dsp: string | null) => {
  let URL;

  switch (dsp) {
    case DSP_ADFORM:
      URL = ADFORM_ALL_TOUCH_REPORTS_URL;
      break;
    default:
      URL = ALL_TOUCH_REPORTS_URL;
      break;
  }

  return api.post<AllTouchReport>(URL, payload);
};

const getReportTemplates = () => {
  return api.get<ReportTemplate[]>(REPORTS_TEMPLATES_URL);
};

const downloadReport = (reportId: string) => {
  return api.get<unknown>(`${REPORTS_DOWNLOAD_URL}/${reportId}`, { responseType: 'blob' });
};

const getReportStatus = (reportId: string) => {
  return api.get<ReportStatusResponse>(`${REPORTS_STATUS_URL}/${reportId}`);
};

const deleteReport = (reportId: string) => {
  return api.delete(`${REPORTS_URL}/${reportId}`);
};

export const reportApi = {
  getReports,
  savePerformanceReport,
  saveAllTouchReport,
  getReportTemplates,
  deleteReport,
  downloadReport,
  getReportStatus,
};
